<!--  -->
<template>
  <div class="total">
    <img style="width: 100%" src="@/../static/img/partner.jpg" alt="" />
    <div style="width: 5.5rem; margin: 0.6rem auto">
      <img style="width: 100%" src="@/../static/img/partnerTwo.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {},
};
</script>
<style rel='stylesheet/less' lang='less' scoped>
.total {
  width: 100%;
  height: 100%;
  margin-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/partner.vue